// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".srh__bg-pulse{animation:bgPulse 1.2s infinite}@keyframes bgPulse{0%{background-color:rgba(0,113,33,.6)}60%{background-color:#007121}to{background-color:rgba(0,113,33,.6)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
